export function compactObject (obj) {
    return Object.keys(obj)
        .filter((key) => {
            return obj.hasOwnProperty(key) && obj[key] !== void 0
        })
        .reduce((acc, key) => {
            acc[key] = obj[key]

            return acc
        }, {})
}
